/**
 * @generated SignedSource<<a3422e0fe79dc3dc8fb62efac2a7fbf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHeaderAssignedBadge_storeViewer$data = {
  readonly assignedCount: number;
  readonly " $fragmentType": "TeamHeaderAssignedBadge_storeViewer";
};
export type TeamHeaderAssignedBadge_storeViewer$key = {
  readonly " $data"?: TeamHeaderAssignedBadge_storeViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderAssignedBadge_storeViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeaderAssignedBadge_storeViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedCount",
      "storageKey": null
    }
  ],
  "type": "StoreViewer",
  "abstractKey": null
};

(node as any).hash = "72b4740f4014512aa61aebac6a42df4e";

export default node;
